import LabelDetailsContainer from "@arelia-components/LabelDetails/LabelDetailsContainer";
import { GridLayout } from "@arelia-components/layout/GridLayout";
import MembersContainer from "@arelia-components/Members/MembersContainer";
import SocialsContainer from "@arelia-components/Socials/SocialsContainer";
import { Account } from "@arelia-types/index";
import AccountDetailsContainer from "./components/AccountDetails/AccountDetailsContainer";
import AvatarContainer from "./components/Avatar/AvatarContainer";
import ChangePassword from "./components/ChangePassword";

type Props = {
  account: Account;
  saveAccount: (values: Partial<Account>) => void;
}

export default function ProfilePresenter({ account, saveAccount }: Props) {
  return (
    <>
      <GridLayout>
        <AccountDetailsContainer accountDetails={account} update={saveAccount}></AccountDetailsContainer>
        <LabelDetailsContainer bandName={account.band?.name} location={account.band?.location} update={saveAccount}></LabelDetailsContainer>
        <AvatarContainer></AvatarContainer>
        <ChangePassword></ChangePassword>
        <SocialsContainer social={account.customerInfo?.social || []} update={saveAccount} />
        <MembersContainer members={account.band?.members || []} update={saveAccount} />
      </GridLayout>
    </>
  );
}